export default __webpack_public_path__ + "static/media/icon_handyqr-3.6e4f4911.jpg";